function setCookie(name, value, hours, domain) {
    const date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=" + domain;
}
function getCookie(name) {
    const cookies = document.cookie.split(";");
    const items = cookies.filter((c) => c.split("=")[0].trim() == name);
    return items.length > 0 ? items[0].split("=")[1].trim() : null;
}

export { getCookie, setCookie };
//# sourceMappingURL=cookie.js.map
